import { useMutation } from "@tanstack/react-query"

import type { InterviewAnswers } from "../components/wizard/wizard-types"

import { aiGenerateFull } from "../api/use-cases-api"

export function useAiGenerateFull() {
  return useMutation({
    mutationFn: (answers: InterviewAnswers) => aiGenerateFull(answers),
  })
}
